// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"bots-settings_checkboxWrapper__376eM","tooltipWrapper":"bots-settings_tooltipWrapper__3WEp6"};